<template>
    <!-- 骨架组件 -->
    <el-skeleton
    :rows="rows" 
    :animated="true"
    :count="count"
    :loading="isLoading"
    :throttle="throttle"
    :class="className"
    >   
        <!-- 骨架插槽 -->
        <template v-slot:template>
            <slot name="template"></slot>
        </template>
        <!-- 真是渲染插槽 -->
        <template>
            <slot></slot>
        </template>
    </el-skeleton>
</template>
<script>
export default {
    name:"VelSkeleton",
    props:{
        rows:Number,
        count:Number,
        isLoading:Boolean,
        throttle:Number,
        className:[String,Array]
    },
    data() {
        return {
            
        };
    },
    methods: {
        
    }
}
</script>